<script setup lang="ts">
import BaseButton from '@tix/ds/components/atoms/BaseButton.vue'

import { useIdentityStore } from '@/stores/identity'

const identityStore = useIdentityStore()
</script>

<template>
  <BaseButton
    class="login-link"
    hierarchy="inline"
    intent="confirm"
    size="sm"
    type="button"
    @click="identityStore.login()"
  >
    <slot />
  </BaseButton>
</template>
